module.exports = new __parcel__URL__("worker.487a2036.js").toString();